<template>
    <!-- eslint-disable -->
    <footer class="footer">

        <div class="footer__container">

            <!--==========================================
							TOP
			===========================================-->

            <div class="footer__top" v-if="!hideLogoBelt">

                <img :src="'logo2.webp'|assetsImg"  alt="Bridgerocks World" class="footer__logo">

                <h2>
                    {{ 'BRIDGE TO A WORLD OF OPPORTUNITIES' | i }}
                </h2>

                <div class="footer__line"></div>

            </div>



            <!--==========================================
							LINKS
			===========================================-->

            <div class="footer__grid">

                <!-- SERVICES -->

                <div class="footer__column">

                    <h3>{{ 'Services' | i }}</h3>

                    <ul>
                        <li v-for="(item, itemIndex) in services" :key="itemIndex"><a :href="item.href  | cr" @click="(item.onClick ? item.onClick($event, this) : null); $emit((item.key? item.key : null ));">{{ item.label | i }}</a></li>
                    </ul>

                </div>

                <!-- COMPANY -->

                <div class="footer__column">

                    <h3>{{ 'Company' | i }}</h3>

                    <ul>
                        <li v-for="(item, itemIndex) in company" :key="itemIndex"><a :href="item.href  | cr" @click="(item.onClick ? item.onClick($event, this) : null); $emit((item.key? item.key : null ));">{{ item.label | i }}</a></li>
                    </ul>

                </div>

                <!-- CONNECT -->

                <div class="footer__column">

                    <h3>{{ 'Portfolio' | i }}</h3>

                    <ul>
                        <li v-for="(item, itemIndex) in portfolio" :key="itemIndex"><a :href="item.href  | cr" @click="(item.onClick ? item.onClick($event, this) : null); $emit((item.key? item.key : null ));">{{ item.label | i }}</a></li>
                    </ul>

                    <h3>{{ 'Connect' | i }}</h3>

                    <ul>
                        <li v-for="(item, itemIndex) in socials" :key="itemIndex"><a :href="item.href  | cr" @click="(item.onClick ? item.onClick($event, this) : null); $emit((item.key? item.key : null ));">{{ item.label | i }}</a></li>
                    </ul>

                </div>

            </div>



            <!--==========================================
						BOTTOM
			===========================================-->

            <div class="footer__bottom">

                <p>
                    ©{{ cYear }}  Bridgerocks World Enterprises. {{ 'All Rights Reserved' | i }}.
                </p>

                <span>
                    {{ 'Built for Visionaries' | i }}.
                </span>

            </div>

        </div>

    </footer>
</template>

<script>
/* eslint-disable */

// https://bridgerocks.us.tempcloudsite.com/sites/Ventures.html

export default {
	name: "navFooter",
    props: {
        hideLogoBelt: {
            type: Boolean,
            default: false
        },
        company: {
            type: Array,
            default: () => [
                { label: 'Manifesto', href: 'site_br_manifest'},
                { label: 'Corporate', href: 'site_br_bridgerocks'},
                { label: 'Reyrock Studio', href: 'site_br_reyrock_landing'},
                { label: 'Privacy Policy', href: '/pages/privacy-policy' },
                { label: 'Terms of Service', href: '/pages/terms-of-service' },
                { label: 'Site map', href: '#', key: 'displaySiteMap', onClick: (event) => { event.preventDefault(); } }
            ]
        },
        services: {
            type: Array,
            default: () => [
                { label: 'Strategic Advisory', href: 'site_br_managment' },
                { label: 'Operation/Production', href: 'site_br_services' },
                { label: 'Capital', href: 'site_br_capital' },
                // { label: 'Property Innovation', href: 'site_br_reyrockproperties' },
                // { label: 'Venture Creation', href: 'site_br_reyrockventures' },
                // { label: 'Talent', href: 'site_br_reyrocktalents' }
            ]
        },
        portfolio: {
            type: Array,
            default: () => [
                { label: 'Properties', href: 'site_br_reyrockproperties' },
                { label: 'Ventures', href: 'site_br_reyrockventures' },
                { label: 'Talents', href: 'site_br_reyrocktalents' },
            ]
        },
        socials: {
            type: Array,
            default: () => [
                // { label: 'LinkedIn', icon: 'fa-brands fa-linkedin-in', href: '#' },
                // { label: 'Instagram', icon: 'fa-brands fa-instagram', href: '#' },
                // { label: 'Facebook', icon: 'fa-brands fa-facebook-f', href: '#' },
                { label: 'Email', icon: 'fa-solid fa-envelope', href: 'mailto:info@bridgerocksworld.com' }
            ]
        },
        cYear: {
            type: String,
            default: () => (new Date().getFullYear()).toString()
        }
    }
};
</script>



<style lang="scss" scoped>
.footer {
    @media screen and (min-width: 768px) {
        &__grid {
            grid-template-columns: 3fr 3fr 1fr;
        }
    }
    .footer__column {
        ul + h3 {
            margin-top: 2rem;
        }
    }
}
</style>